import {styled} from '@material-ui/core'

const FullWidthImage = styled('img')({
  objectFit: 'cover',
  width: '100%',
})

export default FullWidthImage
